import React, { useRef } from "react";
import DownloadExcel from "../../../../Extra/DownloadExcel";

import { getDaysInFYMonths } from "../../../../Utilitie";

const NKJFlowReceived = ({ data }) => {
  const years = [...new Set(data.map((o) => o.f_year))];
  const monthOrder = [
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
    "JAN",
    "FEB",
    "MAR",
  ];
  const tableRef = useRef();

  return (
    <div>
      {" "}
      <div className="row newUiBody">
        <div className="  border">
          <div className="table-responsive  h-100">
            {" "}
            <table
              ref={tableRef}
              className="table newUiTable table-striped table-hover  "
              style={{ minHeight: "200px" }}
            >
              <thead>
                <tr className="table-dark">
                  {" "}
                  <th>F YEAR</th>
                  <th>AVG PER DAY</th>
                  <th>TOTAL</th>
                </tr>
              </thead>

              <tbody className="align-middle">
                {years.map((year, i) => {
                  let tempMonths = [
                    ...new Set(
                      data
                        .filter((o) => o.f_year === year)
                        .map((o) => o.a_month),
                    ),
                  ];
                  let months = tempMonths.sort(
                    (a, b) => monthOrder.indexOf(a) - monthOrder.indexOf(b),
                  );
                  let days = tempMonths
                    ? getDaysInFYMonths(year?.replace("-", "_"), months)
                    : 1;

                  return (
                    <tr key={i}>
                      <td>{year}</td>
                      <td>
                        {(
                          data
                            .filter((o) => o.f_year === year)
                            .reduce((sum, o) => {
                              return sum + o.total;
                            }, 0) / days
                        ).toFixed(2)}
                      </td>

                      <td>
                        {data
                          .filter((o) => o.f_year === year)
                          .reduce((sum, o) => {
                            return sum + o.total;
                          }, 0)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <DownloadExcel
              tableRef={tableRef}
              fileName={`Financial Year Summary NKJ Yard Ex  -}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NKJFlowReceived;
